// extracted by mini-css-extract-plugin
export default {"title":"Title__title___lAn92","tagArea":"Title__tagArea___fL7hM"};